import type { PasskeyCallbackReason } from '@modules/passkey/interfaces/passkey-callback.interface';

export interface PasskeySupportResult {
  isSupported: boolean;
  reason?: PasskeyCallbackReason;
}

export const getPasskeySupport = (): PasskeySupportResult => {
  if (!window.isSecureContext) {
    return {
      isSupported: false,
      reason: 'unsupportedDevice',
    };
  }

  if (!window.PublicKeyCredential || !navigator.credentials) {
    return {
      isSupported: false,
      reason: 'unsupportedDevice',
    };
  }

  return {
    isSupported: true,
  };
};
